export default {
  title: 'Activate reservations',
  buttons: {
    cancel: 'Cancel',
    activate: 'Activate reservations',
  },
};
